// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBannerCarouselStyles } from "@rpsc/App/Widgets/XBannerCarousel/XBannerCarousel";
import { DivWrapper } from "@rpsc/XDL/constants";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

xBannerCarouselStyles.slideshowWrapper = {
    css: css`
        position: relative;
        &&&&& {
            .carousel-main-wrapper > div {
                width: 100%;
            }

            .xng-pagination-container {
                padding: 0 5px;
            }
        }
    `,
};
xBannerCarouselStyles.slideCenteringWrapperStyles = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-width: 40%;

        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

xBannerCarouselStyles.slideContentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 100%;
        color: ${color("text")};

        ${({ backgroundColor, tabletOnly }: any) =>
            tabletOnly
                ? css`
                      ${xScreen("lte", "md")} {
                          background-color: ${backgroundColor};
                      }
                  `
                : css`
                      background-color: ${backgroundColor};
                  `}
    `,
};
xBannerCarouselStyles.slideOverlayWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        justify-content: start;
        flex-grow: 1;
        padding: 40px 56px;
        && {
            width: 100%;
            ${xScreen("lte", "md")} {
                background-color: ${({ backgroundColor }: any) => backgroundColor};
                padding: 20px 0;
                flex-grow: 1;
            }
        }
    `,
};
xBannerCarouselStyles.wrapper = {
    css: css`
        ${layoutContainer}
        z-index: 1;
        width: 100%;
    `,
};
xBannerCarouselStyles.headingText = {
    css: css`
        &&& {
            ${TypographyStyle} {
                line-height: 49px;
                font-size: 36px;
                font-weight: ${fontConfig.weight.black};
                color: ${color("common.black")};
                margin-bottom: 0;
            }
        }
    `,
};

xBannerCarouselStyles.subheadingText = {
    css: css`
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
        &&& {
            ${TypographyStyle} {
                line-height: 28px;
                font-size: 20px;
                color: ${color("common.black")};
                font-weight: ${fontConfig.weight.bold};
                margin-bottom: 0;
            }
        }
    `,
};

xBannerCarouselStyles.slideButton = {
    sizeVariant: "large",
    css: css`
        width: fit-content;
    `,
};

xBannerCarouselStyles.pictureWrapper = {
    css: css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 446px;

        ${LazyImageStyle} {
            width: 100%;
            height: 446px;

            ${xScreen("lte", "lg")} {
                height: 463px;
            }
            ${xScreen("lte", "md")} {
                height: 215px;
            }
            ${xScreen("lte", "sm")} {
                height: 202px;
            }
            picture {
                display: flex;
                width: 100%;
                flex: 1;
            }
            img {
                object-fit: cover;
                width: 100%;
                ${({ displayImageWithFullHeight }: any) =>
                    !displayImageWithFullHeight &&
                    css`
                        clip-path: ellipse(81% 50% at 50% 36%);
                        ${xScreen("lte", "lg")} {
                            clip-path: ellipse(85% 50% at 50% 32%);
                        }
                        ${xScreen("lte", "md")} {
                            clip-path: none;
                        }
                    `}
            }
        }
        ${xScreen("lte", "lg")} {
            height: 463px;
        }
        ${xScreen("lte", "md")} {
            height: 215px;
            position: relative;
        }
        ${xScreen("lte", "sm")} {
            height: 202px;
        }
    `,
};

xBannerCarouselStyles.zoneContainer = {
    css: css`
        z-index: 2;
        display: flex;
        padding: 2px 0;
        &:has(${DivWrapper}:empty) {
            display: none;
        }
    `,
};
